// extracted by mini-css-extract-plugin
export default {"input":"SInputBtn_input__RyCZ3"};